<template>




 <h1></h1>
<!--
<router-link to="/one" >one</router-link> <br>
<router-link :to="{path:'/two/'}" >two</router-link> <br>
<router-link to="/three" >three</router-link>
<WebDocumentViewer/>
-->



<login v-if="!this.$store.state.login"/>

 <Frame v-else/>
 
  

 

</template>





<script>
 
import Frame from './components/Frame'
import Login from './components/Login'


 

export default {
  

 components:{ Frame, Login}
    
 
  
}
</script>

<style>
 
</style>
